<template>
  <div class="auth-content">
    <a href="https://nativenokuchi.com/" class="guide">
      ※ 新しいアカウントを作成するには、https://nativenokuchi.com/
      からメールアドレスを登録してください。
    </a>
    <div class="left">
      <img class="symbol" src="@/assets/nklogo_.png" />
      <!-- <div class="welcome">Welcome</div> -->
      <!-- <div class="third-party-authes">
        <p>既にお持ちのアカウントでご利用頂けます</p>
        <img
          src="@/assets/facebook.svg"
          @click="signInWithFacebook"
          alt="facebook"
        />
        <img src="@/assets/google.svg" @click="signInWithGoogle" alt="google" />
        <img
          src="@/assets/twitter.svg"
          @click="signInWithTwitter"
          style="margin-left: 11px"
          alt="twitter"
        />
      </div>-->
    </div>
    <!-- LOGIN -->
    <div class="right" v-if="!$route.query['email']">
      <h3>サインイン</h3>

      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="メールアドレス">
          <el-input type="email" v-model="email"></el-input>
        </el-form-item>
        <el-form-item label="パスワード">
          <el-input type="password" v-model="password"></el-input>
        </el-form-item>
        <div class="message">{{ message }}</div>

        <el-form-item style="margin: 0">
          <div style="text-align:right">
            <button
              @click.prevent="signIn"
              class="button login"
              :class="{ 'loading disabled': loading }"
            >{{ loading ? "サインイン中" : "サインイン" }}</button>
          </div>
        </el-form-item>
      </el-form>
      <div class="forgot" @click="goToResetPage">サインインでお困りの場合はこちら</div>
    </div>

    <!-- LOGIN -->
    <div class="right" v-if="$route.query['email']">
      <h3>ユーザー登録</h3>

      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
        class="demo-ruleForm"
      >
        <el-form-item label="メールアドレス" prop="email">
          <el-input
            prefix-icon="el-icon-user"
            type="email"
            disabled
            v-model="$route.query['email']"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="パスワード" prop="pass">
          <el-input
            prefix-icon="el-icon-lock"
            type="password"
            v-model="ruleForm.pass"
            autocomplete="off"
          ></el-input>
          <div class="strength">{{ passStrength }}</div>
        </el-form-item>

        <el-form-item class="passInput" label="確認パスワード" prop="checkPass">
          <el-input
            prefix-icon="el-icon-lock"
            type="password"
            v-model="ruleForm.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <button
            class="button"
            type="primary"
            :class="{'loading disabled': loading }"
            @click.prevent="submitForm('ruleForm')"
          >{{ loading ? "登録中" : "登録" }}</button>
          <button
            class="button white"
            @click.prevent="resetForm('ruleForm')"
            style="margin-left: 20px"
          >リセット</button>
        </el-form-item>
      </el-form>
      <div class="error">{{ createErrorMessage }}</div>
      <div class="forgot" @click="goToLogin">既にアカウントをお持ちの方はこちら</div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import { mapGetters } from "vuex";
import store from "@/store";
import axios from "axios";
const zxcvbn = require("zxcvbn");
const CREATE_ACCOUNT = {
  "auth/invalid-email": "メールアドレスの形式に誤りがあります",
  "auth/email-already-in-use": "このメールアドレスは既に使用されています"
};

export default {
  name: "Authentification",
  components: {
    Modal: require("@/components/Modal").default
  },
  watch: {
    ruleForm: {
      deep: true,
      handler: function(input) {
        var result = ["弱い", "少し弱い", "中", "少し強い", "強い"];
        // zxcvbnで判定し、resultにある文言を返す
        var score = zxcvbn(input.pass).score;
        console.log(result[score]);
        this.passStrength = result[score];
      }
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードを入力してください"));
      } else if (value.length < 8) {
        callback(new Error("パスワードは8文字以上入力してください"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードを入力してください"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("2つのパスワードが異なっています"));
      } else {
        callback();
      }
    };
    return {
      passStrength: "",
      ruleForm: {
        pass: "",
        checkPass: ""
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      createErrorMessage: " ",
      email: "",
      loading: false,
      password: "",
      pending: false,
      message: " ",
      form: {
        name: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    })
  },

  mounted() {
    document.title = "ネイティブの口 | サインイン";
  },
  methods: {
    goToLogin() {
      let query = Object.assign({}, this.$route.query);
      delete query.email;
      delete query.keyCode;
      this.$router.replace({ query });
    },
    submitForm(formName) {
      let self = this;
      self.loading = true;
      self.$refs[formName].validate(async valid => {
        if (valid) {
          const sendData = {
            password: this.ruleForm.pass,
            email: this.$route.query["email"],
            keyCode: this.$route.query["keyCode"]
          };
          axios
            .post(
              "https://us-central1-pronaid.cloudfunctions.net/createSingleUser",
              sendData
            )
            .then(async response => {
              // await self.$store.dispatch("auth/init");
              const code = response.data.code;
              if (
                code === "invalid-keycode" ||
                code === "invalid-keycode-or-email"
              ) {
                self.$notify({
                  duration: 0,
                  type: "error",
                  title: "Error",
                  message: response.data.message
                });
                return;
              }
              await firebase
                .auth()
                .signInWithEmailAndPassword(
                  self.$route.query["email"],
                  self.ruleForm.pass
                );
              self.$router.replace("/subscribe");
            })
            .catch(e => {
              self.$notify({
                duration: 0,
                type: "error",
                title: "エラー",
                message: response.data.message
              });
              self.loading = false;
            })
            .finally(() => {
              self.loading = false;
            });
        } else {
              self.loading = false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    register() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    goToResetPage() {
      this.$router.replace("/forgot");
    },
    async signIn() {
      this.loading = true;
      let self = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(async user => {
          setTimeout(() => {
            this.$store.commit("resetState");
            this.$router.replace("/dashboard");
          }, 1000);
        })
        .catch(err => {
          this.loading = false;
          console.log(err.code);
          switch (err.code) {
            case "auth/invalid-email":
              self.message = "メールアドレスまたはパスワードが無効です。";
              break;
            case "auth/wrong-password":
              self.message = "メールアドレスまたはパスワードが無効です。";
              break;
            case "auth/user-not-found":
              self.message = "メールアドレスまたはパスワードが無効です。";
              break;
            default:
              self.message = "メールアドレスまたはパスワードが無効です。";
          }
        });
    },
    signInWithGoogle() {
      let self = this;
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
      firebase.auth().languageCode = "ja";
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          self.$router.replace("/dashboard");
        })
        .catch(function(error) {
          const errorCode = error.code;
          const errorMessage = error.message;
          const email = error.email;
          const credential = error.credential;
        });
    },
    signInWithFacebook() {
      let self = this;
      const provider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().languageCode = "ja";
      provider.setCustomParameters({
        display: "popup"
      });
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          console.log(result);
          const token = result.credential.accessToken;
          const user = result.user;
        })
        .catch(function(err) {
          console.log(err);
          switch (err.code) {
            case "auth/invalid-email":
              self.message = "メールアドレスの形式が間違っています";
              break;
            case "auth/wrong-password":
              self.message = "パスワードが間違っています";
              break;
            case "auth/account-exists-with-different-credential":
              self.message =
                "このメールアドレスですでにユーザー登録がされています";
              break;
            default:
              self.message = "エラーが発生しました";
          }
        });
    },
    signInWithTwitter() {
      let self = this;
      const provider = new firebase.auth.TwitterAuthProvider();
      firebase.auth().languageCode = "ja";
      provider.setCustomParameters({
        display: "popup"
      });
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          self.$router.replace("/dashboard");
          console.log(result);
          const token = result.credential.accessToken;
          const user = result.user;
        })
        .catch(function(err) {
          console.log(err);
          switch (err.code) {
            case "auth/invalid-email":
              self.message = "メールアドレスの形式が間違っています";
              break;
            case "auth/wrong-password":
              self.message = "パスワードが間違っています";
              break;
            case "auth/account-exists-with-different-credential":
              self.message =
                "このメールアドレスですでにユーザー登録がされています";
              break;
            default:
              self.message = "エラーが発生しました";
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: 1.8rem;
  font-weight: bold;
}
.auth-content {
  h1 {
    margin: 10px 0;
    font-size: 1.5rem;
  }
  box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.1);
  background-color: white;
  box-sizing: border-box;
  display: inline-block;
  height: 420px;
  width: 820px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  &:hover {
    .left {
      .symbol {
        /* transform: scale(1.03); */
        opacity: 1;
      }
    }
  }
}

.left {
  width: 35%;
  height: 100%;
  /* background-color: $main-color; */
  float: left;
  position: relative;
  text-align: center;
  .symbol {
    width: 150px;
    margin-top: 200px;
    /* opacity: 0.9; */
    transition: all 0.3s ease;
    /* opacity: 0.8; */
  }
  .welcome {
    color: #888;
    font-weight: bold;
    font-size: 2rem;
    text-align: center;
    margin-top: 10px;
  }
}

.third-party-authes {
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: 10px;
  p {
    margin: 0;
    font-size: 0.88rem;
    color: white;
  }
  img {
    cursor: pointer;
    width: 25px;
    margin: 8px;
    &:hover {
      transform: scale(1.1);
    }
  }
}

.right {
  background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  padding: 20px 40px;
  width: 65%;
  height: 100%;
}

.label {
  color: #888;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

.logo {
  width: 140px;
  display: block;
  margin: 0 auto 30px auto;
}
.login {
  margin: 20px 0;
  margin-left: auto;
  vertical-align: middle;
  padding: 5px 30px;
  font-size: 0.9rem;
  border-radius: 20px;
  transition: padding 0.5s ease, opacity 0.5s ease, width 0.5s ease;
  img {
    width: 20px;
    vertical-align: middle;
  }
}

.loading {
  background-image: url("../../assets/spinner.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: 90%;
  background-size: 22px;
  padding: 5px 43px 5px 25px;
}
.message {
  color: $main-color;
  font-weight: bold;
  text-align: center;
  font-size: 0.83rem;
}
.guide {
  position: absolute;
  bottom: -30px;
  font-size: 0.82rem;
  color: #999;
}

.forgot {
  margin-top: 10px;
  color: #999;
  font-weight: bold;
  text-align: center;
  font-size: 0.8rem;
  cursor: pointer;
  &:hover {
    color: #777;
  }
}
.error {
  color: #f88;
  font-weight: bold;
  text-align: center;
  font-size: 0.8rem;
}

.strength {
  position: absolute;
  font-size: 0.8rem;
  font-weight: bold;
  top: 0;
  right: 30px;
  bottom: 0;
  margin: 0 auto;
}

.passInput {
  position: relative;
}
</style>
